export default {
  navButton:
    ({ selected }) =>
    ({ palette }) => ({
      maxWidth: '18vw',
      minWidth: '18vw',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexDirection: 'column',
      position: 'relative',
      textAlign: 'center',
      color: selected ? palette.primary.main : palette.text.primary,
      '& svg': {
        fill: selected ? palette.primary.main : palette.text.primary,
      },
      '& p': {
        mt: 0.5,
        fontSize: 12,
        fontWeight: 600,
      },
    }),
};
